import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SettingStore } from '../../../stores/setting.store';

/**
 * 푸터 컴포넌트
 * @description 메인 레이아웃의 하단 푸터를 담당
 * @author OOO <your-email@lepisode.team>
 */
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  imports: [RouterLink],
})
export class FooterComponent {
  protected readonly settingStore = inject(SettingStore);

  /** 현재 연도 */
  readonly currentYear = new Date().getFullYear();
}
